import { useLanguage } from '../contexts/LanguageContext';
import { i18nTexts } from '../translations/i18nTexts';

export function useTexts() {
  const { lang } = useLanguage();
  return i18nTexts[lang];
}
